import { publicPath } from '../vue.config'

import Home from "./pages/Home.vue";
import Login from './pages/Login.vue'

import Index from './pages/Index.vue'

import Welcome from './pages/Welcome.vue'

import CarList from './pages/CarList.vue'
import CarPosition from './pages/CarPosition.vue'

import NonContractOrder from './pages/orderManage/nonContractOrder/table.vue'
import NonContractOrderOwn from './pages/orderManage/nonContractOrder/own/table.vue'
import NonContractOrderOwnTobe from './pages/orderManage/nonContractOrder/own/tobe/table.vue'
import NonContractOrderOwnIng from './pages/orderManage/nonContractOrder/own/ing/table.vue'
import NonContractOrderOwnArrive from './pages/orderManage/nonContractOrder/own/arrive/table.vue'
import NonContractOrderOwnUncheck from './pages/orderManage/nonContractOrder/own/uncheck/table.vue'
import NonContractOrderOwnDone from './pages/orderManage/nonContractOrder/own/done/table.vue'
import OrderNoContractAdd from './pages/orderManage/nonContractOrder/add.vue'
import OrderNoContractView from './pages/orderManage/nonContractOrder/view.vue'
import OrderNoContractView1 from './pages/orderManage/nonContractOrder/view1.vue'
import OrderNoContractView2 from './pages/orderManage/nonContractOrder/view2.vue'
import OrderNoContractView3 from './pages/orderManage/nonContractOrder/view3.vue'
import OrderNoContractView4 from './pages/orderManage/nonContractOrder/view4.vue'
import OrderNoContractView5 from './pages/orderManage/nonContractOrder/view5.vue'
import OrderNoContractFee from './pages/orderManage/nonContractOrder/fee.vue'

import MakeupList from './pages/orderManage/makeup/table.vue'
import Makeupdetail from './pages/orderManage/makeup/detail.vue'
import Makeupedit from './pages/orderManage/makeup/edit.vue'
// 运单回收站
import recycle from './pages/orderManage/recycle/table.vue'

// 客户管理
import Customer from './pages/customer/manage/table.vue'
import CustomerList from './pages/customer/manage/list.vue'
import CustomerDetail from './pages/customer/manage/detail.vue'
import CustomerEdit from './pages/customer/manage/edit.vue'
import CustomerView from './pages/customer/manage/view.vue'
import CustomerLog from './pages/customer/log/table.vue'
import CustomerLogList from './pages/customer/log/list.vue'
import CustomerKai from './pages/customer/manage/kai.vue'
import CustomerRoute from './pages/customer/manage/route.vue'

// import Vehicle from './pages/vehicle/manage/table.vue'
import VehicleTab from './pages/vehicle/manage/team.vue'
import VehicleList from './pages/vehicle/manage/list.vue'
import VehicleList1 from './pages/vehicle/manage/list1.vue'
import VehiclePosition from './pages/vehicle/manage/position.vue'
import VehicleViewTrip from './pages/vehicle/manage/viewTrip.vue'
import VehicleDetail from './pages/vehicle/manage/detail.vue'
import VehicleDocument from './pages/vehicle/manage/document.vue'
import VehicleInsurance from './pages/vehicle/manage/insurance.vue'
import VehicleView from './pages/vehicle/manage/view.vue'
import VehicleViewUrl from './pages/vehicle/manage/viewUrl.vue'
import VehicleHang from './pages/vehicle/hang/table.vue'
import VehicleHangTab from './pages/vehicle/hang/tabpage.vue'
import VehicleHangInsurance from './pages/vehicle/hang/insurance.vue'
import VehicleHangDocument from './pages/vehicle/hang/document.vue'
import VehicleHangDetail from './pages/vehicle/hang/detail.vue'
import VehicleHangView from './pages/vehicle/hang/view.vue'
import Vehicleinspect from './pages/vehicle/inspect/table.vue'
import VehicleinspectDetail from './pages/vehicle/inspect/detail.vue'
import VehicleinspectView from './pages/vehicle/inspect/view.vue'
import VehicleinspectTables from './pages/vehicle/inspect/tables.vue'

// 临期查询
import VehicleDocuments from './pages/vehicle/documents/tabpage.vue'
import VehicleDocumentsList from './pages/vehicle/documents/table.vue'
import VehicleInsuranceList from './pages/vehicle/documents/insuranceTable.vue'

// 违章管理
import BreakRules from './pages/vehicle/breakRules/table.vue'
import BreakRulesList from './pages/vehicle/breakRules/list.vue'
import BreakRulesDetailList from './pages/vehicle/breakRules/detailList.vue'

// 维保管理
import FixList from './pages/fix/manage/table.vue'
import FixAdd from './pages/fix/manage/add.vue'
import FixDtail from './pages/fix/manage/detail.vue'
import FixExamine from './pages/fix/manage/examine.vue'

import FixConfigTable from './pages/fix/config/table.vue'

import StaffMainAccountant from './pages/staff/mainAccountant/tabpage.vue'
import StaffMainAccountantTable from './pages/staff/mainAccountant/table.vue'
import MainAccountantDetail from './pages/staff/mainAccountant/detail.vue'

import StaffCaptain from './pages/staff/captain/tabpage.vue'
import StaffCaptainTable from './pages/staff/captain/table.vue'
import StaffCaptainDetail from './pages/staff/captain/detail.vue'

import StaffMaintenance from './pages/staff/maintenance/tabpage.vue'
import StaffMaintenanceTable from './pages/staff/maintenance/table.vue'
import Maintenancedetail from './pages/staff/maintenance/detail.vue'

import StaffVehicleService from './pages/staff/vehicleService/tabpage.vue'
import StaffVehicleServiceTable from './pages/staff/vehicleService/table.vue'
import VehicleServiceDetail from './pages/staff/vehicleService/detail.vue'

import StaffDriver from './pages/staff/driver/table.vue'
import StaffDriverTeam from './pages/staff/driver/team.vue'
import StaffDriverList from './pages/staff/driver/list.vue'
import StaffDriverDetail from './pages/staff/driver/detail.vue'
import StaffEscort from './pages/staff/escort/table.vue'
import StaffEscortTeam from './pages/staff/escort/team.vue'
import StaffEscortList from './pages/staff/escort/list.vue'
import StaffEscortDetail from './pages/staff/escort/detail.vue'

import FinanceFeightStatistics from './pages/finance/feightStatistics/table.vue'
import FinanceShipper from './pages/finance/shipper/table.vue'
import ViewOrder from './pages/finance/shipper/viewOrder.vue'
import ContractFix from './pages/finance/shipper/contractFix.vue'
import PaymentHistory from './pages/finance/shipper/paymentHistory.vue'

// 预支款
import FinanceInitialPayment from './pages/finance/initialPayment/table.vue'
import InitialPaymentDetailList from './pages/finance/initialPayment/tableDetails.vue'
import InitialPaymentRecord from './pages/finance/initialPayment/PaymentRecord.vue'
import InitialAllPaymentRecord from './pages/finance/initialPayment/AllPaymentRecord.vue'

import FinanceFixedFee from './pages/finance/fixedFee/table.vue'
import FinanceDrivingFee from './pages/finance/drivingFee/table.vue'

// 油气费汇总
import FinanceOilFee from './pages/finance/oilFee/table.vue'
// 现金加油
import FinanceOilFeeCash from './pages/finance/oilFee/cash.vue'
import FinanceOilFeeOrder from './pages/finance/oilFee/order.vue'
import FinanceOilFeeOrderAll from './pages/finance/oilFee/orderAll.vue'
// 油卡加油
import FinanceOilFeeCard from './pages/finance/oilFee/card.vue'
import FinanceOilFeeCardOrder from './pages/finance/oilFee/cardOrder.vue'
import FinanceOilFeeCardOrderAll from './pages/finance/oilFee/cardOrderAll.vue'
// 定点加油
import FinanceOilFeeSite from './pages/finance/oilFee/site.vue'
import FinanceOilFeeStation from './pages/finance/oilFee/station.vue'
import FinanceOilFeeSiteOrder from './pages/finance/oilFee/siteOrder.vue'
import FinanceOilFeeSiteOrderAll from './pages/finance/oilFee/siteOrderAll.vue'

import FinanceFixedFeeList from './pages/finance/fixedFeeList/table.vue'
import FinanceFixedFeeDetailList from './pages/finance/fixedFeeList/detailList.vue'
import FinanceBaseSalary from './pages/finance/baseSalary/table.vue'
// import FinanceEstimatedProfit from './pages/finance/estimatedProfit/table.vue'
import FinanceEstimatedProfitList from './pages/finance/estimatedProfit/list.vue'
import FinancemonthOrder from './pages/finance/estimatedProfit/monthOrder.vue'
import FinanceMonthFixRecord from './pages/finance/estimatedProfit/monthFixRecord.vue'

import FinanceExpenseSummary from './pages/finance/expenseSummary/table.vue'
import FinanceExpenseSummaryTableDetails from './pages/finance/expenseSummary/tableDetails.vue'
import FinanceMonthlyStatistical from './pages/finance/monthlyStatistical/table.vue'
import FinanceFleetAbnormal from './pages/finance/fleetAbnormal/table.vue'


import SystemLoginLog from './pages/system/loginLog/table.vue'
import StationConfig from './pages/system/stationConfig/table.vue'
import CargoConfig from './pages/system/cargoConfig/table.vue'
import WarningConfig from './pages/system/warningConfig/table.vue'
import InsuranceConfig from './pages/system/insuranceConfig/table.vue'
import DocumentConfig from './pages/system/documentConfig/table.vue'
import ReminderConfig from './pages/system/reminderConfig/table.vue'
import VehicleTypeConfig from './pages/system/vehicleTypeConfig/table.vue'
import ExtraFeeConfig from './pages/system/extraFeeConfig/table.vue'
import Others from './pages/system/others/table.vue'

import HelpOperation from './pages/help/operation/table.vue'
import HelpLog from './pages/help/log/list.vue'
import HelpImprove from './pages/help/improve/list.vue'

const routes = [
  { path: '*', redirect: '/admin/welcome' },
  { path: '/login', component: Login },
  { path: '/Indexs', component: Index },
  {
    path: '/admin',
    component: Home,
    redirect: '/admin/index',
    children: [
      { path: 'index', component: Index },
      { path: 'welcome', component: Welcome },
      {
        path: 'carposition',
        component: CarList,
        redirect: 'carposition/list',
        children: [
          { path: 'list', component: CarPosition }
        ],
      },
    ],
  },
  // 运单管理
  {
    path: '/order',
    component: Home,
    redirect: '/order/nocontract',
    children: [
      {
        path: 'nocontract',
        component: NonContractOrder,
        redirect: 'nocontract/own',
        children: [
          {
            path: 'own',
            component: NonContractOrderOwn,
            redirect: 'own/tobe',
            children: [
              { path: 'tobe', component: NonContractOrderOwnTobe },
              { path: 'ing', component: NonContractOrderOwnIng },
              { path: 'arrive', component: NonContractOrderOwnArrive },
              { path: 'uncheck', component: NonContractOrderOwnUncheck },
              { path: 'done', component: NonContractOrderOwnDone },
            ],
          },
        ],
      },
      { path: 'position', component: VehiclePosition },
      { path: 'nocontractadd', component: OrderNoContractAdd },
      { path: 'nocontractview', component: OrderNoContractView },
      { path: 'nocontractview1', component: OrderNoContractView1 },
      { path: 'nocontractview2', component: OrderNoContractView2 },
      { path: 'nocontractview3', component: OrderNoContractView3 },
      { path: 'nocontractview4', component: OrderNoContractView4 },
      { path: 'nocontractview5', component: OrderNoContractView5 },
      { path: 'nocontractfee', component: OrderNoContractFee },
      { path: 'makeup', component: MakeupList },
      { path: 'makeupdetail', component: Makeupdetail },
      { path: 'makeupedit', component: Makeupedit },
      { path: 'recycle', component: recycle },
      { path: 'recycleview', component: OrderNoContractView2 },
      { path: 'recyclefee', component: OrderNoContractFee },
    ],
  },
  // 客户管理
  {
    path: '/customer',
    component: Home,
    redirect: '/customer/manage',
    children: [
      {
        path: 'manage',
        component: Customer,
        redirect: 'manage/table/1',
        children: [
          {
            path: 'table',
            component: CustomerList,
          },
          {
            path: 'table/:idx',
            component: CustomerList,
          },
        ],
      },
      { path: 'detail', component: CustomerDetail },
      { path: 'edit', component: CustomerEdit },
      { path: 'view', component: CustomerView },
      { path: 'kai', component: CustomerKai },
      { path: 'route', component: CustomerRoute },
      {
        path: 'log',
        component: CustomerLog,
        redirect: 'log/table',
        children: [
          {
            path: 'table',
            component: CustomerLogList,
          },
        ],
      },
    ],
  },
  // 车辆管理
  {
    path: '/vehicle',
    component: Home,
    redirect: '/vehicle/manage',
    children: [
      {
        path: 'manage',
        component: VehicleTab,
        redirect: 'manage/table/1',
        children: [
          {
            path: 'table/1',
            component: VehicleList,
          },
          {
            path: 'table/2',
            component: VehicleList,
          },
          {
            path: 'table/3',
            component: VehicleList1,
          },
        ],
      },
      { path: 'detail', component: VehicleDetail },
      { path: 'insurance', component: VehicleInsurance },
      { path: 'insurance1', component: VehicleInsurance },
      { path: 'insurance2', component: VehicleInsurance },
      { path: 'document', component: VehicleDocument },
      { path: 'document1', component: VehicleDocument },
      { path: 'document2', component: VehicleDocument },
      { path: 'position', component: VehiclePosition },
      { path: 'viewTrip', component: VehicleViewTrip },
      { path: 'view', component: VehicleView },
      { path: 'viewurl', component: VehicleViewUrl },
      {
        path: 'hang',
        component: VehicleHangTab,
        redirect: 'hang/table',
        children: [
          {
            path: 'table',
            redirect: 'table/1',
            component: VehicleHang,
          },
          {
            path: 'table/:status',
            component: VehicleHang,
          },
        ],
      },
      { path: 'hangInsurance', component: VehicleHangInsurance },
      { path: 'hangDocument', component: VehicleHangDocument },
      { path: 'hangdetail', component: VehicleHangDetail },
      { path: 'hangview', component: VehicleHangView },
      // 违章管理
      {
        path: 'breakRules',
        component: BreakRules,
        redirect: 'breakRules/detailList',
        children: [
          { path: 'detailList', component: BreakRulesDetailList },
          { path: 'list', component: BreakRulesList },

        ],
      },
      {
        path: 'inspect',
        component: Vehicleinspect,
      },
      { path: 'inspectdetail', component: VehicleinspectDetail },
      { path: 'inspectview', component: VehicleinspectView },
      { path: 'inspecttables', component: VehicleinspectTables },
      // 临期查询
      {
        path: 'documents',
        component: VehicleDocuments,
        redirect: 'documents/list',
        children: [
          { path: 'list', component: VehicleDocumentsList },
          { path: 'insurancelist', component: VehicleInsuranceList },
        ],
      },
    ],
  },
  // 维保管理
  {
    path: '/fix',
    component: Home,
    redirect: '/fix/list',
    children: [
      { path: 'list', component: FixList },
      { path: 'detail', component: FixDtail },
      { path: 'add', component: FixAdd },
      { path: 'examine', component: FixExamine },
      { path: 'config', component: FixConfigTable },
      //{ path: 'configdetail', component: FixConfigDetail },
    ],
  },
  // 人员管理
  {
    path: '/staff',
    component: Home,
    redirect: '/staff/captain',
    children: [
      {
        path: 'mainAccountant',
        component: StaffMainAccountant,
        redirect: 'mainAccountant/table',
        children: [
          {
            path: 'table',
            redirect: 'table/1',
            component: StaffMainAccountantTable,
          },
          {
            path: 'table/:iswork',
            component: StaffMainAccountantTable,
          },
        ],
      },
      { path: 'mainAccountantDetail', component: MainAccountantDetail },
      {
        path: 'captain',
        component: StaffCaptain,
        redirect: 'captain/table',
        children: [
          {
            path: 'table',
            redirect: 'table/1',
            component: StaffCaptainTable,
          },
          {
            path: 'table/:iswork',
            component: StaffCaptainTable,
          },
        ],
      },
      { path: 'captainDetail', component: StaffCaptainDetail },

      {
        path: 'maintenance',
        component: StaffMaintenance,
        redirect: 'maintenance/table',
        children: [
          {
            path: 'table',
            redirect: 'table/1',
            component: StaffMaintenanceTable,
          },
          {
            path: 'table/:iswork',
            component: StaffMaintenanceTable,
          },
        ],
      },
      { path: 'maintenanceDetail', component: Maintenancedetail },
      {
        path: 'vehicleService',
        component: StaffVehicleService,
        redirect: 'vehicleService/table',
        children: [
          {
            path: 'table',
            redirect: 'table/1',
            component: StaffVehicleServiceTable,
          },
          {
            path: 'table/:iswork',
            component: StaffVehicleServiceTable,
          },
        ],
      },
      { path: 'vehicleServiceDetail', component: VehicleServiceDetail },
      {
        path: 'driver',
        component: StaffDriver,
        redirect: 'driver/table',
        children: [
          {
            path: 'table',
            redirect: 'table/1/list/1',
            component: StaffDriverTeam,
            children: [
              {
                path: 'list',
                redirect: 'list/1',
                component: StaffDriverList,
              },
              {
                path: 'list/:iswork',
                component: StaffDriverList,
              },
            ],
          },
          {
            path: 'table/:idx',
            redirect: 'table/1/list',
            component: StaffDriverTeam,
            props: true,
            children: [
              {
                path: 'list',
                redirect: 'list/1',
                component: StaffDriverList,
              },
              {
                path: 'list/:iswork',
                component: StaffDriverList,
              },
            ],
          },
        ],
      },
      { path: 'driverDetail', component: StaffDriverDetail },
      {
        path: 'escort',
        component: StaffEscort,
        redirect: 'escort/table',
        children: [
          {
            path: 'table',
            redirect: 'table/1/list/1',
            component: StaffEscortTeam,
            children: [
              {
                path: 'list',
                redirect: 'list/1',
                component: StaffEscortList,
              },
              {
                path: 'list/:iswork',
                component: StaffEscortList,
              },
            ],
          },
          {
            path: 'table/:idx',
            redirect: 'table/1/list',
            component: StaffEscortTeam,
            props: true,
            children: [
              {
                path: 'list',
                redirect: 'list/1',
                component: StaffEscortList,
              },
              {
                path: 'list/:iswork',
                component: StaffEscortList,
              },
            ],
          },
        ],
      },
      { path: 'escortDetail', component: StaffEscortDetail },
    ],
  },
  // 财务管理
  {
    path: '/finance',
    component: Home,
    redirect: '/finance/list',
    children: [
      { path: 'feightStatistics', component: FinanceFeightStatistics },
      { path: 'shipper', component: FinanceShipper },
      { path: 'viewOrder', component: ViewOrder },
      { path: 'contractFix', component: ContractFix },
      { path: 'paymentHistory', component: PaymentHistory },
      { path: 'initialPayment', component: FinanceInitialPayment },
      { path: 'initialPaymentDetailList', component: InitialPaymentDetailList },
      { path: 'initialPaymentDetailFee', component: OrderNoContractFee },
      { path: 'initialPaymentRecord', component: InitialPaymentRecord },
      { path: 'initialAllPaymentRecord', component: InitialAllPaymentRecord },
      { path: 'fixedFee', component: FinanceFixedFee },
      { path: 'drivingFee', component: FinanceDrivingFee },
      {
        path: 'oilFee',
        component: FinanceOilFee,
        redirect: 'oilFee/cash',
        children: [
          {
            path: 'cash',
            component: FinanceOilFeeCash,
          },
          {
            path: 'cashorder',
            component: FinanceOilFeeOrder,
          },
          {
            path: 'cashorderall',
            component: FinanceOilFeeOrderAll,
          },
          {
            path: 'card',
            component: FinanceOilFeeCard,
          },
          {
            path: 'cardorder',
            component: FinanceOilFeeCardOrder,
          },
          {
            path: 'cardorderall',
            component: FinanceOilFeeCardOrderAll,
          },
          {
            path: 'site',
            component: FinanceOilFeeSite,
          },
          {
            path: 'station',
            component: FinanceOilFeeStation,
          },
          {
            path: 'siteorder',
            component: FinanceOilFeeSiteOrder,
          },
          {
            path: 'siteorderall',
            component: FinanceOilFeeSiteOrderAll,
          },
        ],
      },
      { path: 'oilfeedetails', component: OrderNoContractFee },
      { path: 'fixedFeeList', component: FinanceFixedFeeList },
      { path: 'fixedFeeDetailList', component: FinanceFixedFeeDetailList },
      { path: 'baseSalary', component: FinanceBaseSalary },
      {
        path: 'estimatedProfit',
        component: FinanceEstimatedProfitList,
        // component: FinanceEstimatedProfit,
        // redirect: 'estimatedProfit/table',
        // children: [
        //   {
        //     path: 'table',
        //     redirect: 'table/1',
        //     component: FinanceEstimatedProfitList,
        //   },
        //   {
        //     path: 'table/:idx',
        //     component: FinanceEstimatedProfitList,
        //   },
        // ],
      },
      { path: 'monthorder', component: FinancemonthOrder },
      { path: 'monthfixrecord', component: FinanceMonthFixRecord },
      { path: 'expenseSummary', component: FinanceExpenseSummary },
      { path: 'expenseSummaryFee', component: OrderNoContractFee },
      { path: 'oilfeeFee', component: OrderNoContractFee },
      { path: 'tabledetails', component: FinanceExpenseSummaryTableDetails },
      { path: 'monthlyStatistical', component: FinanceMonthlyStatistical },
      { path: 'financeFleetAbnormal', component: FinanceFleetAbnormal },
      { path: 'abnormalFee', component: OrderNoContractFee },
    ],
  },
  // 系统设置
  {
    path: '/system',
    component: Home,
    redirect: '/system/reminderConfig',
    children: [
      { path: 'loginLog', component: SystemLoginLog },
      { path: 'stationConfig', component: StationConfig },
      { path: 'cargoConfig', component: CargoConfig },
      { path: 'warningConfig', component: WarningConfig },
      { path: 'insuranceConfig', component: InsuranceConfig },
      { path: 'documentConfig', component: DocumentConfig },
      { path: 'reminderConfig', component: ReminderConfig },
      { path: 'vehicleTypeConfig', component: VehicleTypeConfig },
      { path: 'extraFeeConfig', component: ExtraFeeConfig },
      { path: 'others', component: Others },
    ],
  },
  // 帮助中心
  {
    path: '/help',
    component: Home,
    redirect: '/help/operation',
    children: [
      { path: 'operation', component: HelpOperation },
      { path: 'log', component: HelpLog },
      { path: 'improve', component: HelpImprove },
    ],
  },
]

const ROUTE = {
  mode: 'history',
  base: publicPath,
  routes,
}

export default ROUTE